<template>

	<dl class="nebikiPriceInfo sort-item"
		v-if="(ptInitData.productInfo.NEBIKI_PRICE > 0 && ptInitData.productInfo.NEBIKI_PRICE != ptInitData.productInfo.PRICE) && !(ptInitData.siteKbn == '4' && !ptInitData.loginKbn && ptInitData.priceShowBtoB == 0) && ptInitData.priceShow != 1">
		<!--値引価格 -->
		<dt v-if="(ptInitData.productInfo.POINT_ITEM_KBN == '0' || ptInitData.productInfo.POINT_ITEM_KBN == '2') &&
			(ptInitData.productInfo.NEBIKI_PRICE > 0)">
			<span class='nebikiPriceTitle'>{{ $t('common.labels.nebikiPrice') }}</span>
		</dt>
		<template v-if="(ptInitData.productInfo.POINT_ITEM_KBN == '0' || ptInitData.productInfo.POINT_ITEM_KBN == '2') &&
			(ptInitData.productInfo.NEBIKI_PRICE > 0)">
			<dd v-if="ptInitData.productInfo.TAX_KBN == 1">
				<span class="nebikiPrice">{{ formatPrice(ptInitData.productInfo.NEBIKI_PRICE) }}{{
					$t('common.labels.jpYen') }}</span>
				&nbsp;<template v-if="ptInitData.productInfo.ITEM_ZEI_SET_KBN != '0'"><span class="nebikiPriceZei">{{
					$t('common.labels.taxIncludeSale[1]') }}</span></template>
			</dd>
			<dd v-else>
				<span class="nebikiPrice">{{ formatPrice(ptInitData.productInfo.NEBIKI_PRICE) }}{{
					$t('common.labels.jpYen')
				}}</span>
				&nbsp;<template v-if="ptInitData.productInfo.ITEM_ZEI_SET_KBN != '0'"><span class="nebikiPriceZei">{{
					$t('common.labels.taxIncludeSale[2]') }}</span></template>
				<span class="nebikiPrice">{{ formatPrice(ptInitData.productInfo.NEIBIKI_ZEI_K_TNK) }}{{
					$t('common.labels.jpYen')
				}}</span>
				&nbsp;<template v-if="ptInitData.productInfo.ITEM_ZEI_SET_KBN != '0'"><span class="nebikiPriceZei">{{
					$t('common.labels.taxIncludeSale[1]') }}</span></template>
			</dd>
		</template>
	</dl>
</template>
<script>
import common from "assets/js/common"; 
export default {
	methods: {
		/**
		 * format number value to currency value
		 * @param {number} value, number to format
		 */
		formatPrice: function (value) {
			return common.formatPrice(value);
		},
	},
	name: "nebikiPriceInfo",
	props: {
		ptInitData: {
			type: Object,
			default: null,
		}
	}
}
</script>
